import { CheckoutOrder } from "../models/order"

const cacheKey = "hg::cache::order"

export const setCachedOrder = (order: CheckoutOrder, cartId: string) => {
  localStorage.setItem(
    cacheKey,
    JSON.stringify({
      id: order.order.id,
      cart_id: cartId,
      _links: order.order._links,
    })
  )
}

export const removeCachedOrder = () => {
  localStorage.removeItem(cacheKey)
}

export const getCachedOrderId = () => {
  const cachedOrder = getCachedOrder()
  return cachedOrder?.id
}

export const getCachedOrder = () => {
  const cachedOrder = localStorage.getItem(cacheKey)
    ? (JSON.parse(localStorage.getItem(cacheKey)!) as {
        id: string
        cart_id: string
        _links: Record<string, any>
        adyenPaymentDetailsUrl?: string
      })
    : undefined
  return cachedOrder
}

export const updateCachedOrder = (updates: {
  adyenPaymentDetailsUrl?: string
}) => {
  const cachedOrder = getCachedOrder()
  if (!cachedOrder) {
    return
  }
  const updatedOrder = {
    ...cachedOrder,
    ...updates,
  }
  localStorage.setItem(cacheKey, JSON.stringify(updatedOrder))
}
